import md5js from 'crypto-js/md5.js';
import Haotianjing from '@baidu/map-car-haotianjing';
import axios from 'axios';

/**
 * @module Browser
 * @file 获取运行环境信息
 * @author 王硕 <wangshuo06@baidu.com>
 */

/**
 * 全局ua变量
 * @private
 */
var ua = '';
var isServerEnv = typeof window === 'undefined';
/**
 * 获取安卓系统版本号(eg: 15.0.0 | 15)
 * @public
 *
 * @param isFirst - 是否返回版本号第一位，默认为false
 * @return - 安卓系统版本号
 */

function getAndroidVersion() {
  var isFirst = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (ua.indexOf('android') > 0) {
    var reg = /android [\d._]+/gi;
    var vInfo = ua.match(reg);
    var version = "".concat(vInfo).replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.'); // 得到版本号4.2.2

    if (isFirst) {
      return "".concat(parseInt(version.split('.')[0], 10)); // 得到版本号第一位
    }

    return version;
  }

  return '';
}
/**
 * 获取iOS系统版本号(例如：11.2.2、11)
 * @public
 *
 * @param isFirst 是否返回版本号第一位，默认为false
 * @return IOS系统版本号
 */

function getIosVersion() {
  var isFirst = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (ua.indexOf('like mac os x') > 0) {
    var reg = /os [\d._]+/gi;
    var vInfo = ua.match(reg);
    var version = "".concat(vInfo).replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.');

    if (isFirst) {
      return "".concat(parseInt(version.split('.')[0], 10)); // 得到版本号第一位
    }

    return version;
  }

  return '';
}
/**
 * 获取是否为iphoneX iphone12 等刘海屏系列
 * @public
 *
 * @return 是否为iphoneX iphone12等刘海屏系列
 */

var isPhoneX = function isPhoneX() {
  var xSeriesConfig = [// iphoneX、iphoneXs、iphone11 Pro
  {
    devicePixelRatio: 3,
    width: 375,
    height: 812
  }, // iphone Xs Max、iphone11 Pro Max
  {
    devicePixelRatio: 3,
    width: 414,
    height: 896
  }, // iphone XR、iphone 11
  {
    devicePixelRatio: 2,
    width: 414,
    height: 896
  }, // iphone 12/12 Pro/ iphone13/13 Pro
  {
    devicePixelRatio: 3,
    width: 390,
    height: 844
  }, // 12 Pro Max/ iphone13 Pro Max
  {
    devicePixelRatio: 3,
    width: 428,
    height: 926
  }, // 12 mini/13 mini
  {
    devicePixelRatio: 3,
    width: 360,
    height: 780
  }];

  if (typeof window !== 'undefined' && window) {
    var isIOS = /iphone/gi.test(ua);

    if (!isIOS) {
      return false;
    }

    var _window = window,
        devicePixelRatio = _window.devicePixelRatio,
        screen = _window.screen;
    var width = screen.width,
        height = screen.height;
    return xSeriesConfig.some(function (item) {
      return item.devicePixelRatio === devicePixelRatio && item.width === width && item.height === height;
    });
  }

  return false;
};
/**
 * 获取运行环境信息
 * @public
 *
 * @param isForce - 是否强制重新获取，默认使用缓存
 * @return - 运行环境信息
 */


function getPlatInfo() {
  var plat = {
    isServer: isServerEnv
  };

  if (plat.isServer) {
    return plat;
  }

  plat.isWeibo = ua.includes('weibo');
  plat.isNative = ua.includes('baidumap_');
  plat.isWechat = ua.includes('micromessenger');
  plat.isIos = /\(i[^;]+;( u;)? cpu.+mac os x/.test(ua);
  plat.isAndroid = ua.includes('android') || ua.includes('adr');
  plat.isMobile = /applewebkit.*mobile.*/.test(ua);
  plat.isIPad = ua.includes('ipad');
  plat.os = plat.isIos ? 'ios' : plat.isAndroid ? 'android' : 'others';
  plat.isIphoneX = isPhoneX(); // 是否是iphone x系列: X,XS,XS Max,XR

  plat.is = function (str) {
    return ua.includes(str);
  };

  return plat;
}
/**
 * 重置用户代理字段，如果传参就将其设为用户代理字符串
 * @param userAgent 用户代理字符串，默认值为navigator.userAgent
 */

function setUserAgent() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator.userAgent;
  ua = userAgent.toLowerCase();
}

if (!isServerEnv) {
  setUserAgent();
}

/**
 * @module Convert
 * @file 经纬度和墨卡托坐标转换工具函数
 * @author Modify by quda on 2019/04/19
 */
var EARTHRADIUS = 6370996.81;
var MCBAND = [12890594.86, 8362377.87, 5591021, 3481989.83, 1678043.12, 0];
var LLBAND = [75, 60, 45, 30, 15, 0];
var MC2LL = [[1.410526172116255e-8, 8.98305509648872e-6, -1.9939833816331, 2.009824383106796e2, -1.872403703815547e2, 91.6087516669843, -23.38765649603339, 2.57121317296198, -0.03801003308653, 1.73379812e7], [-7.435856389565537e-9, 8.983055097726239e-6, -0.78625201886289, 96.32687599759846, -1.85204757529826, -59.36935905485877, 47.40033549296737, -16.50741931063887, 2.28786674699375, 1.026014486e7], [-3.030883460898826e-8, 8.98305509983578e-6, 0.30071316287616, 59.74293618442277, 7.357984074871, -25.38371002664745, 13.45380521110908, -3.29883767235584, 0.32710905363475, 6.85681737e6], [-1.981981304930552e-8, 8.983055099779535e-6, 0.03278182852591, 40.31678527705744, 0.65659298677277, -4.44255534477492, 0.85341911805263, 0.12923347998204, -0.04625736007561, 4.48277706e6], [3.09191371068437e-9, 8.983055096812155e-6, 0.00006995724062, 23.10934304144901, -0.00023663490511, -0.6321817810242, -0.00663494467273, 0.03430082397953, -0.00466043876332, 2.5551644e6], [2.890871144776878e-9, 8.983055095805407e-6, -0.00000003068298, 7.47137025468032, -0.00000353937994, -0.02145144861037, -0.00001234426596, 0.00010322952773, -0.00000323890364, 8.260885e5]];
var LL2MC = [[-0.0015702102444, 1.113207020616939e5, 1.704480524535203e15, -1.033898737604234e16, 2.611266785660388e16, -3.51496691766537e16, 2.659570071840392e16, -1.072501245418824e16, 1.800819912950474e15, 82.5], [8.277824516172526e-4, 1.113207020463578e5, 6.477955746671608e8, -4.082003173641316e9, 1.077490566351142e10, -1.517187553151559e10, 1.205306533862167e10, -5.124939663577472e9, 9.133119359512032e8, 67.5], [0.00337398766765, 1.113207020202162e5, 4.481351045890365e6, -2.339375119931662e7, 7.968221547186455e7, -1.159649932797253e8, 9.723671115602145e7, -4.366194633752821e7, 8.477230501135234e6, 52.5], [0.00220636496208, 1.113207020209128e5, 5.175186112841131e4, 3.796837749470245e6, 9.920137397791013e5, -1.22195221711287e6, 1.340652697009075e6, -6.209436990984312e5, 1.444169293806241e5, 37.5], [-3.441963504368392e-4, 1.113207020576856e5, 2.782353980772752e2, 2.485758690035394e6, 6.070750963243378e3, 5.482118345352118e4, 9.540606633304236e3, -2.71055326746645e3, 1.405483844121726e3, 22.5], [-3.218135878613132e-4, 1.113207020701615e5, 0.00369383431289, 8.237256402795718e5, 0.46104986909093, 2.351343141331292e3, 1.58060784298199, 8.77738589078284, 0.37238884252424, 7.45]];

/**
 * @private
 */
function getRange(v, a, b) {
  if (a != null) {
    v = Math.max(v, a);
  }

  if (b != null) {
    v = Math.min(v, b);
  }

  return v;
}
/**
 * @private
 */


function getLoop(v, a, b) {
  while (v > b) {
    v -= b - a;
  }

  while (v < a) {
    v += b - a;
  }

  return v;
}

function convertor(fromPoint, factor) {
  var x = factor[0] + factor[1] * Math.abs(fromPoint[0]);
  var temp = Math.abs(fromPoint[1]) / factor[9];
  var y = factor[2] + factor[3] * temp + factor[4] * temp * temp + factor[5] * temp * temp * temp + factor[6] * temp * temp * temp * temp + factor[7] * temp * temp * temp * temp * temp + factor[8] * temp * temp * temp * temp * temp * temp;
  x *= fromPoint[0] < 0 ? -1 : 1;
  y *= fromPoint[1] < 0 ? -1 : 1;
  return [x, y];
}
/**
  * @param angdeg - 度数
  * @returns 弧度
  */


function toRadians(angdeg) {
  return Math.PI * angdeg / 180;
}
/**
  * 转换经纬度坐标为墨卡托坐标
  * @param point - 经纬度坐标
  * @returns - 墨卡托坐标
  */


function convertLL2MC(point) {
  var temp;
  var factor;
  point[0] = getLoop(point[0], -180, 180);
  point[1] = getRange(point[1], -74, 74);
  temp = point.slice(0);

  for (var i = 0; i < LLBAND.length; i++) {
    if (temp[1] >= LLBAND[i]) {
      factor = LL2MC[i];
      break;
    }
  }

  if (!factor) {
    for (var _i = LLBAND.length - 1; _i >= 0; _i--) {
      if (temp[1] <= -LLBAND[_i]) {
        factor = LL2MC[_i];
        break;
      }
    }
  }

  var mc = convertor(point, factor);
  var result = mc && [+mc[0].toFixed(2), +mc[1].toFixed(2)];
  return result;
}
/**
  * 转换墨卡托坐标为经纬度坐标
  * @param {Array} point - 墨卡托坐标
  * @returns {Array} - 经纬度坐标
  */


function convertMC2LL(point) {
  var temp;
  var factor;
  temp = [Math.abs(point[0]), Math.abs(point[1])];

  for (var i = 0; i < MCBAND.length; i++) {
    if (temp[1] >= MCBAND[i]) {
      factor = MC2LL[i];
      break;
    }
  }

  var lnglat = convertor(point, factor);
  var result = lnglat && [lnglat[0].toFixed(6), lnglat[1].toFixed(6)];
  return result;
}
/**
  * 转换像素点坐标为经纬度坐标
  * @param x 坐标x
  * @param y 坐标y
  * @param zoom 缩放倍数
  * @returns 经纬度坐标
  */


function pixelToLngLat(x, y, zoom) {
  return convertMC2LL([x / Math.pow(2, zoom - 18), y / Math.pow(2, zoom - 18)]);
}
/**
  * 转换经纬度坐标为像素点坐标
  * @param lng 纬度
  * @param lat 经度
  * @param zoom 缩放比例
  * @returns 像素点坐标
  */


function lngLatToPixel(lng, lat, zoom) {
  var mercator = convertLL2MC([lng, lat]);
  var x = mercator && mercator[0] * Math.pow(2, zoom - 18);
  var y = mercator && mercator[1] * Math.pow(2, zoom - 18);
  return [Math.ceil(x), Math.ceil(y)];
}
/**
  * 计算平面内两点间的距离
  * @param point1 墨卡托坐标
  * @param point2 墨卡托坐标
  * @returns 距离
  */


function getDistanceOfPixel(px1, px2) {
  var distance = 0;

  if (!px1 || !px2) {
    return distance;
  }

  if (px1.x && px1.y && px2.x && px2.y) {
    var dx = parseFloat(String(px1.x)) - parseFloat(String(px2.x));
    var dy = parseFloat(String(px1.y)) - parseFloat(String(px2.y));
    distance = Math.sqrt(dx * dx + dy * dy);
  }

  return distance;
}
/**
  * 计算球面距离
  * @param {Object} point1 - 点1
  * @param {Object} point2 - 点2
  * @returns {number} - 距离
  */


function getDistanceBySphere(point1, point2) {
  var x1 = point1.x;
  var y1 = point1.y;
  var x2 = point2.x;
  var y2 = point2.y;
  return EARTHRADIUS * Math.acos(Math.sin(y1) * Math.sin(y2) + Math.cos(y1) * Math.cos(y2) * Math.cos(x2 - x1));
}
/**
  * 计算两个墨卡托点间的距离
  * @param {Object} point1 - 墨卡托坐标
  * @param {Object} point2 - 墨卡托坐标
  * @returns {number} - 距离
  */


function getDistanceOfMC(point1, point2) {
  var p1 = convertMC2LL([point1.x, point1.y]);
  var np1 = {
    x: toRadians(+p1[0]),
    y: toRadians(+p1[1])
  };
  var p2 = convertMC2LL([point2.x, point2.y]);
  var np2 = {
    x: toRadians(+p2[0]),
    y: toRadians(+p2[1])
  };
  return getDistanceBySphere(np1, np2);
}

/**
 * @module Cookie
 * @file cookie操作相关
 * @author liuyanan06 <liuyanan06@baidu.com>
 */

/**
 * 获取cookie
 * @param name 键名称
 * @return cookie的相应键的值
 */
function getCookie(name) {
  if (document.cookie.length > 0) {
    var c_start = document.cookie.indexOf(name + '=');

    if (c_start !== -1) {
      c_start = c_start + name.length + 1;
      var c_end = document.cookie.indexOf(';', c_start);

      if (c_end === -1) {
        c_end = document.cookie.length;
      }

      return decodeURIComponent(document.cookie.substring(c_start, c_end));
    }
  }

  return '';
}
/**
 * 存储键值对到cookie,并设置有效期
 * @param name - 键
 * @param value - 值
 * @param expiredays - 有效期（单位：天）
 */


function setCookie(name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = name + '=' + encodeURIComponent(value) + (expiredays ? ';expires=' + exdate.toUTCString() : '');
}
/**
 * 删除指定的键
 * @param name - 键
 */


function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);

  if (cval) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toUTCString();
  }
}

/**
 * @module copyText
 * @file 移动端复制文字工具
 * @author quda
 */
function emptyFn$1(bool) {
  return bool;
}
/**
 * 获取要复制的文本
 * @param el - 目标dom元素
 * @returns - 复制的文本
 */


function select(el) {
  var selectedText = ''; // 复制的文本

  if (el.nodeName === 'SELECT') {
    el.focus();
    selectedText = el.value;
  } else if (el.nodeName === 'INPUT' || el.nodeName === 'TEXTAREA') {
    var isReadOnly = el.hasAttribute('readonly');
    var tempEl = el; // 如果属性为只读，不能选中

    if (!isReadOnly) {
      el.setAttribute('readonly', '');
    }

    tempEl.select();
    tempEl.setSelectionRange(0, tempEl.value.length); // 设置选中target的范围

    if (!isReadOnly) {
      el.removeAttribute('readonly');
    }

    selectedText = tempEl.value;
  } else {
    if (el.hasAttribute('contenteditable')) {
      el.focus();
    } // 创建getSelection，用来选中除input、testarea、select元素


    var selection = window.getSelection(); // 创建createRange，用来设置getSelection的选中范围

    var range = document.createRange(); // 选中范围设置为target元素

    range.selectNodeContents(el);

    if (selection) {
      // 清空getSelection已选中的范围
      selection.removeAllRanges(); // 把target元素设置为getSelection的选中范围

      selection.addRange(range); // 记录值

      selectedText = selection.toString();
    }
  }

  return selectedText;
}

function copyAction(cb) {
  var succeeded;

  try {
    succeeded = document.execCommand('copy');
  } catch (err) {
    succeeded = false;
  }

  cb(succeeded);
}
/**
 * 从文档中获取指定的DOM元素
 * @param target 元素的选择器或DOM元素
 * @returns 指定的DOM元素
 */


function getTarget(target) {
  if ('string' === typeof target) {
    return document.querySelector(target);
  } else if (target && target.nodeName && (target.nodeType === 1 || target.nodeType === 9)) {
    return target;
  }

  return null;
}
/**
 * 清除文案选中
 */


function clearSelection() {
  window.getSelection().removeAllRanges();
}
/**
 * 复制文字
 * @param target - 需要复制文本所在dom容器的选择器或DOM元素
 * @param {Object} opts - 参数集合
 * @param {Function} opts.cb - 回调函数，默认为() => {}
 * @param {boolean} opts.clearSelect - 是否清除文字的选中态，默认为true
 */


var copyText = function copyText(target) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$cb = _ref.cb,
      cb = _ref$cb === void 0 ? emptyFn$1 : _ref$cb,
      _ref$clearSelect = _ref.clearSelect,
      clearSelect = _ref$clearSelect === void 0 ? true : _ref$clearSelect;

  var t = getTarget(target);

  if (!t) {
    cb(false);
    return;
  }

  select(t);
  copyAction(cb);
  clearSelect && clearSelection();
};

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
  * 获取接口加密参数
  * @param salt - 加盐
  * @returns - {s: 签名, t: 时间戳(秒)}
  */
var getST = function getST(salt) {
  var t = Date.now() / 1000 >> 0;
  var s = md5js("".concat(t).concat(salt)).toString();
  return {
    s: s,
    t: t
  };
};
/**
  * 获取字符串的哈希值
  * @param {string} str - 原始字符串
  * @param {boolean} caseSensitive - 是否区分大小写，默认为false
  * @returns {number} - hash串
  */

var getHashCode = function getHashCode(str) {
  var caseSensitive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!caseSensitive) {
    str = str.toLowerCase();
  } // 1315423911=b'1001110011001111100011010100111'


  var hash = 1315423911;
  var i;
  var ch;

  for (i = str.length - 1; i >= 0; i--) {
    ch = str.charCodeAt(i);
    hash ^= (hash << 5) + ch + (hash >> 2);
  }

  return hash & 0x7fffffff;
};
/**
 * 基于接口配置对接口参数进行过滤
 * @param props - 入参
 * @param filter - 需要包含的key值集合
 * @return 过滤后的参数集合
 */

var filterProps = function filterProps(props, filter) {
  if (filter && filter.length > 0) {
    var res = {};

    for (var key in props) {
      if (filter.includes(key)) {
        res[key] = props[key];
      }
    }

    return res;
  }

  return props;
};
/**
 * 根据对象key进行排序
 * @param {Object} obj - 目标对象
 * @return {Object} - 排序后的对象
 */

var ksort = function ksort(obj) {
  var keys = Object.keys(obj).sort();
  var sortedObj = {};

  var _iterator = _createForOfIteratorHelper$1(keys),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      sortedObj[key] = obj[key];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return sortedObj;
};
/**
 * 计算sign
 * @param {Object} param - 对象集合
 * @param {string} salt - 盐值
 * @return {string} md5 sign
 */

function makeSign(param, salt) {
  var p = ksort(param);
  var arr = [];

  for (var key in p) {
    if (Object.prototype.hasOwnProperty.call(p, key)) {
      // 默认不转码，如需转码在入参中处理
      arr.push("".concat(key, "=").concat(p[key]));
    }
  }

  var str = arr.join('&') + salt;
  return md5js(str).toString();
}

/**
 * @module Date
 * @file 日期格式处理
 * @author wangshuo <wangshuo06@baidu.com>
 */

/**
 * 将 Date 转化为指定格式的 String
 * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * @example
 * formatDate(new Date(), "yyyy-MM-dd hh:mm:ss.S") => 2020-07-02 08:09:04.423
 * formatDate(new Date(), "yyyy-M-d h:m:s.S")      => 2020-7-2 8:9:4.18
 * @param date - 日期
 * @param fmt - 目标日期格式
 * @returns  - 格式化后的日期
 */
function formatDate(date, fmt) {
  var o = {
    'M+': date.getMonth() + 1,
    // 月份9
    'd+': date.getDate(),
    // 日
    'h+': date.getHours(),
    // 小时
    'm+': date.getMinutes(),
    // 分
    's+': date.getSeconds(),
    // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3),
    // 季度
    S: date.getMilliseconds() // 毫秒

  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, "".concat(date.getFullYear()).substring(4 - RegExp.$1.length));
  }

  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substring(('' + o[k]).length));
    }
  }

  return fmt;
}
/**
 * 比较指定时间是否在指定时间段内（无日期格式容错）
 * @param ds 时间点数组，时间点可以是时间戳[毫秒]，也可以是符合ISO、GMT规范的时间字符串，注意时间数组必须是升序的
 * @param n 指定时间点，默认为当前时间点
 * @returns 返回指定时间段内大于等于指定时间的索引
 */


function getTimePeriod() {
  var ds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var n = arguments.length > 1 ? arguments[1] : undefined;
  // 动态设定时间
  var now = n ? new Date(n).getTime() : Date.now(); // 判断时间点在时间区间的位置

  var index = ds.map(function (d) {
    return new Date(d).getTime();
  }).sort(function (a, b) {
    return a - b;
  }).findIndex(function (cn) {
    return now <= cn;
  });
  return index === -1 ? ds.length : index;
}

/**
 * @module debounce
 * @file 防抖
 * @author liuyanan06 <liuyanan06@baidu.com>
 */

/**
 * 防抖
 * @param fn - 被防抖的函数
 * @param opts - 配置项
 * @param delay - 延时（毫秒），默认为100
 * @param firstTimeHandle - 是否首次执行，默认为true
 * @returns - 已经被防抖的函数
 */
function debounce(fn) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$firstTimeHandle = _ref.firstTimeHandle,
      firstTimeHandle = _ref$firstTimeHandle === void 0 ? true : _ref$firstTimeHandle,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 100 : _ref$delay;

  var timeout = null;
  var clickTime = 0;
  var first = true;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (firstTimeHandle) {
      first = Date.now() - clickTime > delay;
      clickTime = Date.now();

      if (first) {
        fn.apply(this, args);
      }
    } else {
      if (timeout) {
        clearTimeout(timeout);
      }

      timeout = window.setTimeout(function () {
        fn.apply(_this, args);
        timeout = null;
      }, delay);
    }
  };
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
}

/**
 * @module ObjectType
 * @file 获取真实js数据类型
 * @author liuyanan06 <liuyanan06@baidu.com>
 */

/**
 * 获取真实js数据类型
 * @param obj 输入的数据
 * @return - 数据类型 Null\Object\Promise...
 * @see => https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Data_structures
 */
function objectType(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1);
}

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * 将url中的参数 a=1&b=2&c=[3,4] 转成对象 { a: 1, b: 2, c: [3, 4] }
 * @param str - 待处理的字符串
 * @param decodeValue - 是否使用decodeURIComponent方法，默认为true
 * @return 将查询参数转化为的对象
 */

function parseUrlStringToObject(str) {
  var decodeValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var obj = {};

  if (!str) {
    return obj;
  }

  var arr = str.split('&');
  var decode = decodeValue ? decodeURIComponent : function (v) {
    return v;
  };

  var _iterator = _createForOfIteratorHelper(arr),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var k = _step.value;

      var _k$split = k.split('='),
          _k$split2 = _slicedToArray(_k$split, 2),
          key = _k$split2[0],
          value = _k$split2[1]; // 判断a=&b=2的情况 去掉a


      if (value) {
        value = decode(value);

        try {
          var temp = JSON.parse(value);
          var type = objectType(temp);

          if (type === 'Array' || type === 'Object') {
            value = temp;
          }
        } catch (e) {// 不处理
        }

        obj[key] = value;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return obj;
}
/**
 * 获取url中参数，传入了url就从url获取，没有传递就从location.href获取
 * @param url url
 * @return 对象
 */

function getParamsFromUrl(url) {
  var target = url ? new URL(url) : window.location;

  if (target.hash.includes('?')) {
    return parseUrlStringToObject(target.hash.split('?').pop());
  }

  if (target.search.includes('?')) {
    return parseUrlStringToObject(target.search.split('?').pop());
  }

  return {};
}
/**
 * 将 { a: 1, b: 2, c: [3, 4] } 转成 a=1&b=2&c=[3,4]
 * @param obj 对象
 * @param encodeValue 是否使用encodeURIComponent方法，默认为true
 * @return url
 */

function parseObjectToUrlString(obj) {
  var encodeValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (objectType(obj) !== 'Object') {
    return '';
  }

  var arr = [];
  var tmp = '';
  var encode = encodeValue ? encodeURIComponent : function (v) {
    return v;
  };

  var deal = function deal(v) {
    var type = objectType(v);

    if (type === 'Array' || type === 'Object') {
      return JSON.stringify(v);
    }

    return encode(v);
  };

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k)) {
      var v = obj[k];
      tmp = "".concat(k, "=").concat(deal(v));
      arr.push(tmp);
    }
  }

  return arr.join('&');
}
/**
 * 向url追加参数，处理向url添加参数?和&的问题
 * @param href - url
 * @param param - 参数
 * @return 追加后的url
 */

function appendParam(href, param) {
  if (!param || JSON.stringify(param) === '{}') {
    return href;
  }

  if (objectType(param) === 'Object') {
    param = parseObjectToUrlString(param);
  }

  if (!href) {
    href = '';
  }

  if (href.endsWith('?')) {
    href += param;
  } else if (href.endsWith('&')) {
    if (href.includes('?')) {
      href += param;
    } else {
      href += "?".concat(param);
    }
  } else {
    if (href.includes('?')) {
      href += "&".concat(param);
    } else {
      href += "?".concat(param);
    }
  }

  return href;
}
/**
 * url过滤，目前过滤字段为BDUSS、cuid
 * @public
 *
 * @param url 被过滤的url
 * @param paramsArr 过滤的参数名称，默认是['BDUSS', 'cuid']
 * @return 返回被过滤之后的url
 */

function filterUrl(url, paramsArr) {
  if (objectType(paramsArr) !== 'Array') {
    paramsArr = ['BDUSS', 'cuid'];
  }

  paramsArr.forEach(function (type) {
    // 匹配参数在中间、首位、末尾的情况
    var reg = new RegExp(type + '=[^&]*&|' + '&?' + type + '=[^&]*', 'ig');
    url = url.replace(reg, '');
  });
  return url;
}

/**
 * @module JSONP
 * @file 跨域请求
 * @author quda
 */
/**
 * jsonp跨域请求
 * @public
 *
 * @param url - 请求url
 * @param param - 请求参数
 * @param options - 配置项
 * @param options.jsonpCallbackPrefix - 全局回调函数前缀，默认为’jsonp'
 * @param options.timeout - 超时（毫秒），默认为5000
 * @param options.jsonp - JSONP回调查询参数的名称
 * @return - Promise
 */

function jsonp(url) {
  var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$jsonpCallbackPre = _ref.jsonpCallbackPrefix,
      jsonpCallbackPrefix = _ref$jsonpCallbackPre === void 0 ? 'jsonp' : _ref$jsonpCallbackPre,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 5000 : _ref$timeout,
      _ref$jsonp = _ref.jsonp,
      jsonp = _ref$jsonp === void 0 ? 'callback' : _ref$jsonp;

  var timer = null;
  var md5 = Math.ceil(Math.random() * 100000);
  var callbackName = "".concat(jsonpCallbackPrefix).concat(md5);
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script = document.createElement('script');
  param[jsonp] = callbackName;
  url = appendParam(url, param);
  script.src = url;
  script.type = 'text/javascript';
  target.parentNode && target.parentNode.appendChild(script);

  function clean() {
    script.parentNode && script.parentNode.removeChild(script);
    timer !== null && clearTimeout(timer);
    window[callbackName] = null;
    timer = null;
  }

  return new Promise(function (resolve, reject) {
    window[callbackName] = function (data) {
      clean();

      if (data && 'string' === typeof data) {
        try {
          data = JSON.parse(data);
        } catch (e) {
          console.error('[ERROR] Parse Error.');
          reject({
            errno: -1,
            errmsg: "[ERROR] Parse Error.url is:".concat(url),
            data: data
          });
        }
      }

      resolve(data);
    }; // 加载错误


    script.addEventListener('error', function (err) {
      clean();
      reject({
        errno: -2,
        errmsg: "[ERROR] Load Error: ".concat(JSON.stringify(err)),
        data: {
          url: url
        }
      });
    }); // 超时

    if (timeout) {
      timer = window.setTimeout(function () {
        clean();
        reject({
          errno: -3,
          errmsg: '[ERROR] Time out.',
          data: {
            url: url
          }
        });
      }, timeout);
    }
  });
}

/**
 * @module duer
 * @file 度口令相关能力
 * @author quda
 */
var DOMIN = 'https://newclient.map.baidu.com/client/';
var PATH = 'maptoken/gettoken';

/**
 * 获取度口令
 * @param params - 度口令接口所需参数集合，此处列出必需字段，详细请参考下方wiki
 * @param params.activity_id - 活动唯一标识，需要向大运营申请
 * @param params.url - 跳转地址，非空值时url需要encode，建议url参数必须使用壳协议链接
 * @param params.source - 流量来源，统计相关
 * @param params.content - 要生成的度口令文案，度口令的占位符用{$token}
 * @see: http://wiki.baidu.com/pages/viewpage.action?pageId=1112603106#id-$%E5%BA%A6%E5%8F%A3%E4%BB%A4%E6%9C%8D%E5%8A%A1%E7%AB%AF%E5%8D%8F%E8%AE%AE%E6%96%87%E6%A1%A3-2.1%E8%8E%B7%E5%8F%96%E5%8F%A3%E4%BB%A4%E6%8E%A5%E5%8F%A3
 * @returns {Promise} - Promise
 * @see http://wiki.baidu.com/pages/viewpage.action?pageId=970305856
 */
var getDuerToken = function getDuerToken(params) {
  var url = DOMIN + PATH;
  var options = {
    jsonp: 'callback'
  };
  return jsonp(url, params, options).then(function (res) {
    if (res.code === 2000 && res.data && res.data.token) {
      return res.data.token; // 如果请求的时候传了content参数，返回拼接好的度口令文案
    }

    console.error("[Error]: \u5EA6\u53E3\u4EE4\u63A5\u53E3\u8BF7\u6C42\u5931\u8D25 ".concat(res.msg));
    throw res;
  }).catch(function (e) {
    if (e && e.errno === -2) {
      throw new Error('网络异常，请稍后再试');
    }

    if (e && e.errno === -3) {
      throw new Error('网络繁忙，请稍后再试');
    }
  });
};

/**
 * @module getScript
 * @file getScript跨域请求js文件
 * @author v_wangshuo06
 */

function getScript(url) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 5000 : _ref$timeout,
      _ref$onetime = _ref.onetime,
      onetime = _ref$onetime === void 0 ? true : _ref$onetime,
      _ref$notime = _ref.notime,
      notime = _ref$notime === void 0 ? true : _ref$notime;

  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    var finish = false;
    var removeEvents;

    var onload = function onload() {
      if (onetime) {
        removeEvents();
      }

      resolve(null);
    };

    var onerror = function onerror(err) {
      removeEvents();
      reject(err);
    };

    removeEvents = function removeEvents() {
      script.removeEventListener('load', onload);
      script.removeEventListener('error', onerror);
      document.body.removeChild(script);
      finish = true;
    };

    var addEvents = function addEvents() {
      script.addEventListener('load', onload);
      script.addEventListener('error', onerror);
      document.body.appendChild(script);
    };

    if (!notime) {
      url = appendParam(url, "_naat=".concat(Date.now()));
    }

    script.setAttribute('src', url);
    addEvents();

    if (timeout) {
      window.setTimeout(function () {
        !finish && onerror('timeout');
      }, timeout);
    }
  });
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var regenerator = runtime_1;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/**
 * @module StringUtils
 * @file 字符串操作集合
 * @author liuyanan06 <liuyanan06@baidu.com>
 */

/**
 * 去除字符串的左右空格
 * @param str 字符串
 * @return 去除左右空格的字符串
 */
function trim(str) {
  if (!str || typeof str !== 'string') {
    return str;
  }

  var trimReg = /(^\s*)|(\s*$)/g;
  return str.replace(trimReg, '');
}
/**
 * 清除左空格
 * @param str 字符串
 * @return 去除左空格的字符串
 */

function trimLeft(str) {
  return str.replace(/^\s+/, '');
}
/**
 * 清除右空格
 * @param str 字符串
 * @return 去除右空格的字符串
 */

function trimRight(val) {
  return val.replace(/\s+$/, '');
}
/**
 * 转为unicode编码
 * @param str 被编码字符串
 * @return 编码的unicode
 */

function encodeUnicode(str) {
  var res = [];

  for (var i = 0; i < str.length; i++) {
    res[i] = ('00' + str.charCodeAt(i).toString(16)).slice(-4);
  }

  return "\\u" + res.join("\\u");
}
/**
 * unicode 解码
 * @param str 被编码字符串
 * @return 解码后的字符串
 */

function decodeUnicode(str) {
  str = str.replace(/\\/g, '%');
  return unescape(str);
}
/**
 * 比较版本大小
 * @param sv1 eg: 15.2.3
 * @param sv2 eg: 15.3.2
 * @return 1 | -1 | 0
 */

function compareSv(sv1, sv2) {
  if (!sv1 || !sv2 || typeof sv1 !== 'string' || typeof sv2 !== 'string') {
    throw new Error('sv should be a string');
  }

  var sv1Array = sv1.split('.').map(function (v) {
    return +v;
  });
  var sv2Array = sv2.split('.').map(function (v) {
    return +v;
  }); // 不足3位的话补0

  var sv1FullArray = Object.assign([0, 0, 0], sv1Array);
  var sv2FullArray = Object.assign([0, 0, 0], sv2Array);

  for (var i = 0, len = 3; i < len; i++) {
    var t = sv1FullArray[i] - sv2FullArray[i];

    if (t > 0) {
      return 1;
    } else if (t < 0) {
      return -1;
    } else if (t === 0 && i + 1 === len) {
      return 0;
    }
  }
}
/**
 * utf-8字符串转base64
 * @param str 需要编码的中文
 * @return base64编码
 */

function utob(str) {
  return window.btoa(unescape(encodeURIComponent(str)));
}
/**
 * base64转utf-8字符串
 * @param str 需要解码的中文
 * @return 解码后的字符串
 */

function btou(str) {
  return decodeURIComponent(escape(window.atob(str)));
}
/**
 * 生成uuid
 * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
 * Be aware Math.random() could cause collisions, but:
 * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
 * @return {string} - a pseudo random id
 */

function genUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0; // 0 ~ 15向下取整

    var v = c === 'x' ? r : r & 0x3 | 0x8; // 为了保证y是8~11之间，即16进制的8~A

    return v.toString(16);
  });
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * 向url添加回调函数
 * @private
 * @param url url
 * @param fn 回调函数
 * @param clear 回调一次后清除，默认true
 * @return 获得追加函数名后的url
 */

function appendCallback(url, fn) {
  var clear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var callbackReg = /[&?]callback=([^&]*)?(&|$)/g;

  if (objectType(fn) !== 'Function' || !url) {
    throw new Error("callback function should be a function and url can't be blank.");
  }

  var callbackName = "naaInternalCallback".concat(Date.now());

  window[callbackName] = function (data) {
    fn.call(window, data);

    if (clear === true) {
      delete window[callbackName];
    }
  };

  var result = url;

  if (url.search(callbackReg) >= 0) {
    result = url.replace(callbackReg, function (match, begin, value, end) {
      return "".concat(begin, "callback=").concat(callbackName).concat(end);
    });
  } else {
    result = appendParam(url, 'callback=' + callbackName);
  }

  return result;
}
/**
 * 创建一个iframe请求,适用于android调用bdapi及openapi
 * @private
 * @param url openapi地址
 * @param notime 是否使用随机戳，默认为false
 */

function makeIframeRequest(url) {
  var notime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var iframe = document.createElement('iframe');
  iframe.style.cssText = 'position:absolute;top:-9999px;left:-9999px;width:0;height:0';
  iframe.id = "naaIframeRequest".concat(Date.now());
  iframe.setAttribute('src', appendParam(url, notime ? '' : "_naat=".concat(Date.now())));
  document.body.appendChild(iframe);
  setTimeout(function () {
    document.body.removeChild(iframe);
  }, 100);
}
/**
 * ios直接跳转,适用于ios调用bdapi及openapi
 * @private
 * @param url openapi地址
 * @param notime 是否使用随机戳，默认为false
 */

function makeAnchorRequest(url) {
  var notime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  location.href = appendParam(url, notime ? '' : "_naat=".concat(Date.now()));
}
/**
 * 请求地图bdapi:开头的协议
 * @public
 * @param url url
 * @param data 调用协议所所用的一些参数 | 调用协议成功后的回调函数
 * @param success 调用协议成功后的回调函数 | 是否一次回调后立即清除回调函数，默认为true
 * @param clear 是否一次回调后立即清除回调函数，默认为true
 * @return 生成的回调函数名，外界调用者可根据回调函数名自行清除回调
 */

function requestBdApi(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var success = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var clear = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (objectType(data) === 'Function') {
    success = data;
    clear = success;
    data = {};
  } // 回调函数名


  var callbackName;
  url = appendParam(url, data);

  if (objectType(success) === 'Function') {
    url = appendCallback(url, success, clear);
    var regex = /([&?])callback=([^&#]*)?(&|#|$)/;
    var result = regex.exec(url);

    if (result && result[2]) {
      callbackName = result[2];
    }
  }

  makeIframeRequest(url, true);
  return callbackName;
}
/**
 * 对调用地图常用的baidumap:开头的openapi的封装
 * @public
 * @param url openapi地址
 * @param data 协议参数
 */

function requestBaiduMapApi(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  url = appendParam(url, data);

  if (getPlatInfo().isAndroid) {
    makeIframeRequest(url, true);
  } else {
    makeAnchorRequest(url, true);
  }
}
/**
 * 获取客户端信息
 * 8.8.0新增的api，获取地图里的信息，本身接口返回的是string型的json串
 * @public
 * @return Promise内传递获取的参数
 * 返回的参数： {
 *      "loc_x": "12948043",
 *      "loc_y": "4845095",
 *      "c": "131",
 *      "cuid": "2827418F1F6639B6E8506FF439FB7343|599773260074553",
 *      "os": "Android22",
 *      "mb": "Nexus 6",
 *      "ov": "Android22",
 *      "sv": "8.8.0",
 *      "bduss": "",
 *      "xdpi": "494",
 *      "ydpi": "492",
 *      "net": "1",
 *      "ua": " baidumap_ANDR"
 *   }
 */

function getNativeInfo() {
  return new Promise(function (resolve) {
    var tmpCallback = function tmpCallback(dataStr) {
      var data = JSON.parse(dataStr);
      resolve(data);
    };

    requestBdApi('bdapi://getNativeInfo', tmpCallback);
  });
}
/**
 * 浏览器打开浮层
 * @private
 */

function openLayer() {
  var layer = document.getElementById('naa-share-fc');

  if (!layer) {
    var imgUrl = 'https://webmap0.bdimg.com/zt/y2016/welfareday/images/share_arrow_5179ee7.png'; // 浮层dom和样式

    var div = document.createElement('div');
    div.style.cssText = 'background-color: rgba(0, 0, 0, 0.7); position: fixed; ' + 'width: 100%; top: 0; left: 0; bottom: 0; z-index: 9999; overflow: hidden;';
    div.id = 'naa-share-fc';
    var img = document.createElement('img');
    img.style.cssText = 'margin-left:19%;width:80%;';
    img.setAttribute('src', imgUrl);
    div.appendChild(img);
    document.body.appendChild(div); // 点击浮层隐藏

    div.addEventListener('click', function () {
      this.style.display = 'none';
    }, false); // 出浮层时不能滚动

    div.addEventListener('touchmove', function (e) {
      e.preventDefault();
    }, false);
  } else {
    layer.style.display = 'block';
  }
}
/**
 * 页面是否可见相关
 * @public
 * @return 对象
 * 返回的对象： {
 *      prefix: '', // 支持的前缀:'webkit' | 'moz' | 'ms' | 'o' | ''
 *      isSupport: true, // 是否支持页面可见性判断属性: true | false
 *      isHidden: Function, // 实时判断页面是否隐藏: isHidden() => true | false
 *      visibilityState: Function // 页面可见的状态: visibilityState() => 'visible' | 'hidden'
 *  }
 */

function getPageVisibility() {
  if (getPlatInfo().isServer) {
    return {};
  }

  var prefixSupport = '';

  var keyWithPrefix = function keyWithPrefix(prefix, key) {
    if (prefix !== '') {
      // 首字母大写
      return prefix + key.slice(0, 1).toUpperCase() + key.slice(1);
    }

    return key;
  }; // 是否支持页面可见性判断属性


  var isPageVisibilitySupport = function () {
    var support = false;

    if (typeof window.screenX === 'number') {
      ['webkit', 'moz', 'ms', 'o', ''].forEach(function (prefix) {
        if (support === false && document[keyWithPrefix(prefix, 'hidden')] !== undefined) {
          prefixSupport = prefix;
          support = true;
        }
      });
    }

    return support;
  }(); // 检测页面对于用户的可见性


  var isHidden = function isHidden() {
    if (isPageVisibilitySupport) {
      return document[keyWithPrefix(prefixSupport, 'hidden')];
    }

    return undefined;
  };

  var visibilityState = function visibilityState() {
    if (isPageVisibilitySupport) {
      return document[keyWithPrefix(prefixSupport, 'visibilityState')];
    }

    return undefined;
  };

  return {
    prefix: prefixSupport,
    isSupport: isPageVisibilitySupport,
    isHidden: isHidden,
    visibilityState: visibilityState,
    getPageVisibility: getPageVisibility
  };
}
/**
 * 唤醒地图
 * @private
 */

var jumpHandler = {
  /**
   * 微信微博下通过浏览器打开
   */
  weixinbo: function weixinbo() {
    openLayer();
  },

  /**
   * 浏览器中
   * @param immediately 是否立即跳转下载页，默认值为false
   * @param downloadPage 下载页地址，默认值为'https://map.baidu.com/zt/client/index/'
   */
  others: function others() {
    var immediately = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var downloadPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https://map.baidu.com/zt/client/index/';

    if (immediately) {
      window.location.href = downloadPage;
    } else {
      var clickedAt = Date.now();
      var pageVisibility = getPageVisibility();
      var isHidden = pageVisibility.isSupport && pageVisibility.isHidden();
      setTimeout(function () {
        if (Date.now() - clickedAt < 1550) {
          if (!isHidden) {
            setTimeout(function () {
              window.location.href = downloadPage;
            }, 0);
          }
        }
      }, 1500);
    }
  }
};
/**
 * 端外根据协议调起地图
 * @public
 * @param opts 配置参数
 * @param opts.openapi openapi，必选
 * @param opts.immediately 是否立即触发调起地图失败后的回调，默认为false
 * @param opts.downloadPage 下载页地址，默认为'https://map.baidu.com/zt/client/index/'
 * @param opts.jumpDownloadPage 跳转到下载页的标志，默认为true
 */

function awakeMapClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$openapi = _ref.openapi,
      openapi = _ref$openapi === void 0 ? '' : _ref$openapi,
      _ref$immediately = _ref.immediately,
      immediately = _ref$immediately === void 0 ? false : _ref$immediately,
      _ref$downloadPage = _ref.downloadPage,
      downloadPage = _ref$downloadPage === void 0 ? 'https://map.baidu.com/zt/client/index/' : _ref$downloadPage,
      _ref$jumpDownloadPage = _ref.jumpDownloadPage,
      jumpDownloadPage = _ref$jumpDownloadPage === void 0 ? true : _ref$jumpDownloadPage;

  var browser = getPlatInfo();

  if (!browser.isNative) {
    // 微信微博浏览器打开，微信下也可以应用宝
    if (browser.isWeibo || browser.isWechat) {
      jumpHandler.weixinbo();
    } else {
      // 浏览器中打开情况
      requestBaiduMapApi(openapi);

      if (jumpDownloadPage) {
        jumpHandler.others(immediately, downloadPage);
      }
    }
  }
}
/**
 * 将h5地址，封装为cost_share协议地址
 * @private
 * @param url h5地址，必选
 * @param opts 配置项
 * @param opts.hiddenNavigation 是否隐藏地图title，默认为false
 * @param opts.hideShare 是否隐藏地图分享按钮，默认为false
 */

function getCostShareApi(url) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$hiddenNavigatio = _ref2.hiddenNavigation,
      hiddenNavigation = _ref2$hiddenNavigatio === void 0 ? false : _ref2$hiddenNavigatio,
      _ref2$hideShare = _ref2.hideShare,
      hideShare = _ref2$hideShare === void 0 ? false : _ref2$hideShare;

  var newUrl = url;
  var objExp = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;

  if (objExp.test(newUrl)) {
    var costSharePrefix = 'baidumap://map/cost_share?popRoot=no&mode=NORMAL_MODE';

    if (hiddenNavigation) {
      costSharePrefix += '&navigationStatus=2&hiddenBackBtn=0&hiddenTitle=1';
    }

    if (hideShare) {
      costSharePrefix += '&hideshare=1';
    }

    costSharePrefix += '&url=' + encodeURIComponent(newUrl);
    var urlPath = location.pathname.split('/');
    urlPath = urlPath && urlPath[urlPath.length - 2] ? urlPath[urlPath.length - 2] : 'main';
    var icon = 'autojump';
    var data = {
      src: 'webapp.cost_share.' + urlPath + '.' + icon,
      needLocation: 'yes'
    };
    var costShareOpenApi = appendParam(costSharePrefix, data);
    return costShareOpenApi;
  }

  console.error('e:请传入正确的url地址');
  return '';
}
/**
 * 判断是否是百度地图协议：baidumap, bdapi
 * @public
 * @param url url
 * @return 是否匹配百度地图协议
 */

function isMapSchema(url) {
  if (!url) {
    return false;
  }

  return url.startsWith('baidumap') || url.startsWith('bdapi');
}
/**
 * 端内使用openapi打开页面
 * @public
 *
 * @example
 * 1. 打开openapi，此时hiddenNavigation无效
 * openUrlByOpenApi(url)
 * 2. 使用透明壳或普通壳打开h5
 * (1) 普通壳
 * openUrlByOpenApi(url)
 * (2) 透明壳
 * openUrlByOpenApi(url, {hiddenNavigation: true})
 * 3. 取消注册IOS的返回事件
 * openUrlByOpenApi(url, {registerIOSBack: false})
 * 4. 关闭自身
 * openUrlByOpenApi(url, {closeSelf: true})
 *
 * @param url - h5地址或openapi
 * @param opts 配置项
 * @param opts.hiddenNavigation 透明壳标志，如果url为openapi，则此属性无效，默认为false
 * @param opts.registerIOSBack 注册IOS的返回事件标志，默认为true
 * @param opts.closeSelf 关闭自身的标志，默认为false（不能打开一个h5地址包装的openapi后，再关闭自身，否则会关闭新开的页面）
 * @param opts.closeSelfTime 关闭当前页的延迟时间（毫秒）,默认为100
 */

function openUrlByOpenApi(url) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$hiddenNavigatio = _ref3.hiddenNavigation,
      hiddenNavigation = _ref3$hiddenNavigatio === void 0 ? false : _ref3$hiddenNavigatio,
      _ref3$registerIOSBack = _ref3.registerIOSBack,
      registerIOSBack = _ref3$registerIOSBack === void 0 ? true : _ref3$registerIOSBack,
      _ref3$closeSelf = _ref3.closeSelf,
      closeSelf = _ref3$closeSelf === void 0 ? false : _ref3$closeSelf,
      _ref3$closeSelfTime = _ref3.closeSelfTime,
      closeSelfTime = _ref3$closeSelfTime === void 0 ? 100 : _ref3$closeSelfTime;

  // 匹配openapi模式时，使用原地址
  // 不匹配时，封装url为openapi
  var openapi = isMapSchema(url) ? url : getCostShareApi(url, {
    hiddenNavigation: hiddenNavigation
  }); // 注册IOS的返回事件

  if (getPlatInfo().isIos && registerIOSBack) {
    requestBdApi('bdapi://robackRefresh');
  } // 打开openapi


  window.location.href = openapi; // 关闭页面自身

  if (closeSelf) {
    setTimeout(function () {
      requestBdApi('bdapi://finishpage?needUpdate=1');
    }, closeSelfTime);
  }
}
/**
 * 端外唤起地图，并打开本页面或目标页
 * @public
 *
 * @example
 * 1. 打开openapi，引导进入端内，此时hiddenNavigation无效
 * openBdMap(url)
 * 2. 打开h5地址，引导进入端内，使用透明壳或普通壳打开当前页
 * (1) 普通壳
 * openBdMap()
 * (2) 透明壳
 * openBdMap({hiddenNavigation: true})
 * 3. 打开h5地址，引导进入端内，使用透明壳或普通壳打开目标页
 * (1) 普通壳
 * openBdMap(url)
 * (2) 透明壳
 * openBdMap(url, {hiddenNavigation: true})
 *
 * @param url h5地址或openapi，默认值为当前页首页的url
 * @param opts 配置项
 * @param opts.hiddenNavigation 透明壳标志，默认为false
 */

function openBdMap() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.origin + location.pathname + location.search;

  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref4$hiddenNavigatio = _ref4.hiddenNavigation,
      hiddenNavigation = _ref4$hiddenNavigatio === void 0 ? false : _ref4$hiddenNavigatio;

  // 如果url为对象，则重置url和opts的值
  if (_typeof(url) === 'object') {
    hiddenNavigation = url.hiddenNavigation;
    url = location.origin + location.pathname + location.search;
  } // 匹配openapi模式，不匹配则封装url为openapi


  var openapi = isMapSchema(url) ? url : getCostShareApi(url, {
    hiddenNavigation: hiddenNavigation
  }); // 唤起端内

  awakeMapClient({
    openapi: openapi
  });
}
/**
 * 转向web百度登录
 * 从登录页面返回或成功登录，会刷新页面
 * @public
 * @param opts 配置项
 * @param opts.tpl 产品线
 * @param opts.authsite 是否展示第三方登录，1: 展示，0: 不展示，默认为0
 */

function goWebLogin() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref5$tpl = _ref5.tpl,
      tpl = _ref5$tpl === void 0 ? 'ma' : _ref5$tpl,
      _ref5$authsite = _ref5.authsite,
      authsite = _ref5$authsite === void 0 ? 0 : _ref5$authsite;

  var loginUrl = 'https://wappass.baidu.com/passport/?';
  loginUrl = appendParam(loginUrl, {
    tpl: tpl,
    authsite: authsite,
    u: location.href,
    adapter: 3 // 去掉h5中的title

  });
  location.href = loginUrl;
}
/**
 * 端内版百度登录
 * 从登录页返回或成功登录，若有回调函数就调用回调函数
 * @public
 * @param opts 配置项
 * @param opts.loginPage 登录方式，可选值为'sms_login'或'normal_login'，默认值为'normal_login'
 * @param opts.thirdLoginEnable 是否支持第三方登录，仅login_page='normal_login'时生效，可选值为'0'或'1'，默认值为0
 * @param opts.loginsourcetype 登陆来源，用于登陆统计，默认值为'登录'
 * @param opts.callback 回调函数的名称
 */

function goBdLogin() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref6$loginPage = _ref6.loginPage,
      loginPage = _ref6$loginPage === void 0 ? 'normal' : _ref6$loginPage,
      _ref6$thirdLoginEnabl = _ref6.thirdLoginEnable,
      thirdLoginEnable = _ref6$thirdLoginEnabl === void 0 ? '0' : _ref6$thirdLoginEnabl,
      _ref6$loginsourcetype = _ref6.loginsourcetype,
      loginsourcetype = _ref6$loginsourcetype === void 0 ? '登录' : _ref6$loginsourcetype,
      _ref6$callback = _ref6.callback,
      callback = _ref6$callback === void 0 ? '' : _ref6$callback;

  requestBdApi('bdapi://login', {
    login_page: loginPage,
    third_login_enable: thirdLoginEnable,
    loginsourcetype: loginsourcetype,
    callback: callback
  });
}
/**
 * 获取客户端参数及url参数
 * @return 对象
 */

function fetchNAParams() {
  var obj = getParamsFromUrl();

  if (getPlatInfo().isNative) {
    // 地图环境下获取nativeInfo
    return getNativeInfo().then(function (result) {
      return _objectSpread$1(_objectSpread$1({}, obj), result);
    });
  }

  return Promise.resolve(obj);
}
/**
 * 登录百度账户，转向端内版登录或web版登录
 * @public
 * @param callback 端内调用时的回调函数的名称，端外时无效，默认为signin
 */

function goToLogin() {
  return _goToLogin.apply(this, arguments);
}

function _goToLogin() {
  _goToLogin = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var callback,
        params,
        sv,
        _params,
        _args = arguments;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            callback = _args.length > 0 && _args[0] !== undefined ? _args[0] : 'signin';

            if (getPlatInfo().isNative) {
              _context.next = 4;
              break;
            }

            goWebLogin();
            return _context.abrupt("return");

          case 4:
            _context.next = 6;
            return fetchNAParams();

          case 6:
            params = _context.sent;
            sv = params.sv || '0.0.0'; // 端内版本低于10.0.0，转向web百度登录

            if (compareSv(sv, '10.10.0') === -1) {
              goWebLogin();
            } else {
              _params = {
                loginPage: 'normal',
                thirdLoginEnable: '0',
                loginsourcetype: '登录',
                callback: callback // js回调函数名称

              };
              goBdLogin(_params);
            }

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _goToLogin.apply(this, arguments);
}

var keyPart1 = 'eyJhcHBfa2V5IjoiNTA0OCIsImFwcF92aWV3IjoicHJvbW90ZSIsImZvcm1fZGVzYyI6IiIsInNlbmRfaW50ZXJ2YWwiOjUw';
var keyPart2 = 'LCJzZW5kX21ldGhvZCI6MywiYnJvd3Nlcl91cmwiOiJodHRwczovL3NvZmlyZS5iYWlkdS5jb20vZGF0YS91YS9hYi5qc29uIn0=';

var getCuid = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var cuid, nativeInfo;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cuid = getParamsFromUrl().cuid;

            if (cuid) {
              _context.next = 6;
              break;
            }

            _context.next = 4;
            return getNativeInfo();

          case 4:
            nativeInfo = _context.sent;
            cuid = nativeInfo.cuid || '';

          case 6:
            return _context.abrupt("return", cuid);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCuid() {
    return _ref.apply(this, arguments);
  };
}();

var initHaotianjing = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    var cuid, initXaf;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getCuid();

          case 2:
            cuid = _context2.sent;
            // 启用昊天镜
            Haotianjing.enableHaoTianJing({
              cuid: cuid,
              // 注意：安全组提供的活动渠道号（appkey），为非必传参数，默认使用车主业务的id
              aid: 5048,
              // 注意：安全组提供的jssdk data-app参数，为非必传参数，默认使用车主业务
              jssdkKey: keyPart1 + keyPart2 // 太长，分成两部分

            }); // xaf为昊天镜的参数
            // 初始化xaf，当window.xaf不存在时，赋一个初始值，避免xaf.getData.Token取不到值时报错

            initXaf = {
              getData: function getData() {
                return {
                  Token: null,
                  view: null
                };
              }
            };
            window.xaf = window.xaf || initXaf; // 兼容昊天镜初始化失败后xaf不存在的异常问题

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function initHaotianjing() {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * @file 数字处理
 * @author wangshuo <wangshuo06@baidu.com>
 */

/** *
 * 格式化数字，返回字符串
 * @param number - 数字
 * @param opts - 配置项
 * @param opts.fraction - 保留的小数点后的位数，默认为2
 * @param opts.rule - 保留小数点时的进制规则，默认为round
 * @param opts.zeroize 小数位数不足时补零，默认为false
 * @param opts.separator - 整数部分的分隔符，默认无
 * @param opts.interval - 间隔位数，默认为3。（配置separator时此项才有效）
 * @param opts.unit - 单位，默认无
 * @returns - 返回被处理后的数字
 */
function formatNumber(number, opts) {
  var defaultOpts = {
    fraction: 2,
    rule: 'round',
    zeroize: false,
    separator: '',
    interval: 3,
    unit: ''
  };
  var allOpts = Object.assign(defaultOpts, opts);

  if (!['round', 'ceil', 'floor'].includes(allOpts.rule)) {
    throw Error('illegal rule');
  }

  var base = Math.pow(10, allOpts.fraction + 1);
  var round = Math[allOpts.rule](number * base / 10);
  var baseline = Math.pow(10, allOpts.fraction);
  var result = String(round / baseline);

  if (allOpts.separator) {
    // 整数部分加分隔符
    var reg = new RegExp("(?=\\B(\\d{".concat(allOpts.interval, "})+(\\.|$))"), 'g');
    result = result.replace(reg, ',');
  }

  if (allOpts.zeroize) {
    var decimals = result.split('.')[1];
    var len = decimals ? allOpts.fraction - decimals.length : allOpts.fraction;
    result += decimals ? '' : '.';
    result += '0'.repeat(len);
  }

  return result + allOpts.unit;
}

/**
 * Module Orienter
 * @file 陀螺仪模块
 * @author quda
 */

/**
 * 陀螺仪模块
 * @param {Object} config - 配置项
 * @param {Function} config.onChange - 陀螺仪参数改变时触发
 * @param {Function} config.onOrient - 屏幕方向改变时触发
 */
var Orienter = /*#__PURE__*/function () {
  function Orienter(config) {
    this._config = void 0;
    this.os = void 0;
    this.initLon = void 0;
    this.lon = void 0;
    this.lat = void 0;
    this.moothFactor = void 0;
    this.boundary = void 0;
    this.direction = void 0;
    this.lastLon = void 0;
    this.lastLat = void 0;
    this._config = Object.assign({
      onChange: function onChange() {// 陀螺仪参数改变时触发
      },
      onOrient: function onOrient() {// 陀螺仪参数改变时触发
      }
    }, config);

    if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      this.os = 'ios';
    } else {
      this.os = navigator.userAgent.includes('Android') || navigator.userAgent.indexOf('Linux') ? 'android' : '';
    }

    this.initLon = null;
    this.lon = this.lat = 0;
    this.moothFactor = 10;
    this.boundary = 320;
    this.direction = window.orientation || 0;
    this.bind();
  }

  var _proto = Orienter.prototype;

  _proto.bind = function bind() {
    window.addEventListener('deviceorientation', this._onChange);
    window.addEventListener('orientationchange', this._onOrient);
  };

  _proto.destroy = function destroy() {
    window.removeEventListener('deviceorientation', this._onChange, false);
    window.removeEventListener('orientationchange', this._onOrient, false);
  };

  _proto._onOrient = function _onOrient(event) {
    this.direction = window.orientation;

    this._config.onOrient(event);

    this.lastLon = this.lastLat = undefined;
  };

  _proto._mooth = function _mooth(x, lx) {
    // 插值为了平滑些
    if (lx === undefined) {
      return x;
    } // 0至360,边界值特例，有卡顿待优化


    if (Math.abs(x - lx) > this.boundary) {
      if (lx > this.boundary) {
        lx = 0;
      } else {
        lx = 360;
      }
    } // 滤波降噪


    x = lx + (x - lx) / this.moothFactor;
    return x;
  };

  _proto._onChange = function _onChange(evt) {
    this.handleOrientation(evt);
  }
  /**
   * 优化陀螺仪参数
   * @param {*} event
   * @see https://w3c.github.io/deviceorientation/
   */
  ;

  _proto.handleOrientation = function handleOrientation(event) {
    var yaw = null;
    var pitch = null;
    var roll = null;
    var alpha = event.alpha;

    if (!this.initLon) {
      this.initLon = alpha;
    } // 修复部分安卓初始场景偏移的问题


    if (this.os === 'android') {
      alpha = event.alpha - this.initLon;
    }

    var radian = Math.PI / 180; // 弧度制

    var info = {
      yaw: alpha * radian,
      pitch: event.beta * radian,
      roll: event.gamma * radian
    };
    var yawCos = Math.cos(info.yaw);
    var yawSin = Math.sin(info.yaw);
    var pitchCos = Math.cos(info.pitch);
    var pitchSin = Math.sin(info.pitch);
    var rollCos = Math.cos(info.roll);
    var rollSin = Math.sin(info.roll); // rotation matrix

    var matrix = [yawSin * rollSin - yawCos * pitchSin * rollCos, -yawCos * pitchCos, yawCos * pitchSin * rollSin + yawSin * rollCos, pitchCos * rollCos, -pitchSin, -pitchCos * rollSin, yawSin * pitchSin * rollCos + yawCos * rollSin, yawSin * pitchCos, -yawSin * pitchSin * rollSin + yawCos * rollCos];

    if (0.9999 < matrix[3]) {
      yaw = Math.atan2(matrix[2], matrix[8]);
      pitch = 0;
      roll = Math.PI / 2;
    } else if (-0.9999 > matrix[3]) {
      yaw = Math.atan2(matrix[2], matrix[8]);
      pitch = 0;
      roll = -Math.PI / 2;
    } else {
      yaw = Math.atan2(-matrix[6], matrix[0]);
      pitch = Math.atan2(-matrix[5], matrix[4]);
      roll = Math.asin(matrix[3]);
    }

    var heading = 180 * -yaw / Math.PI;
    pitch = 180 * -roll / Math.PI;

    this._config.onChange({
      lon: heading + 180,
      lat: pitch
    });
  };

  return Orienter;
}();

/**
 * @module
 * @file 图片预加载，单张或多张
 * @author liuyanan06 <liuyanan06@baidu.com>
 */

/**
  * 图片预加载，单张或多张，不阻塞页面，最多等待500毫秒
  * @param imgs - 图片地址或数组
  * @param options - 配置项
  * @param options.onProcess - 可选，加载进度回调
  * @param options.waitTime - 可选，最长等待时间(ms)
  * @returns - Promise
  */
function preload(imgs) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      onProcess = _ref.onProcess,
      _ref$waitTime = _ref.waitTime,
      waitTime = _ref$waitTime === void 0 ? 500 : _ref$waitTime;

  var loadedCount = 0;
  var total = 1;

  var loadImage = function loadImage(url) {
    return new Promise(function (resolve) {
      var img = new Image();
      var timeout = window.setTimeout(function () {
        resolve(null);
      }, waitTime);

      img.onload = function () {
        loadedCount++;
        onProcess && onProcess(loadedCount / total);
        timeout && clearTimeout(timeout);
        timeout = null;
        resolve(img);
      };

      img.onerror = function () {
        resolve(null);
      };

      img.src = url;
    });
  };

  if (objectType(imgs) === 'Array') {
    total = imgs.length;
    var promiseArray = imgs.map(function (item) {
      return loadImage(item);
    });
    return Promise.all(promiseArray);
  }

  if (!imgs) {
    return;
  }

  var promise = loadImage(imgs);
  return promise;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var baseURL = '';
var defaultOption = {
  baseURL: baseURL,
  timeout: 20000,
  withCredentials: true // 跨域请求时是否需要使用凭证

};
/**
 * get ajax method
 * @param url - 接口路径
 * @param params - 接口参数
 * @param option - 接口配置，目前兼容axios config
 * @returns - 异步接口函数
 */

var get = function get(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var op = Object.assign({}, defaultOption, option);
  return axios.get(url, _objectSpread({
    params: params,
    headers: {
      'Cache-Control': 'no-cache'
    }
  }, op));
};
/**
 * post ajax method
 * @param url - 接口路径
 * @param params - 接口参数
 * @param option - 接口配置，目前兼容axios config
 * @returns- 异步接口函数
 */


var post = function post(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var op = Object.assign({}, defaultOption, option);
  var data = parseObjectToUrlString(params);
  return axios.post(url, data, _objectSpread({
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  }, op));
};

/**
 * @file 异步加载js
 * @author quda
 */

/**
 * 异步加载js资源
 * @param url - 资源链接
 * @param options - 配置
 * @return - Promise
 */
function loadScript(url) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 5000 : _ref$timeout,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? genUUID() : _ref$id,
      _ref$async = _ref.async,
      async = _ref$async === void 0 ? true : _ref$async,
      _ref$globals = _ref.globals,
      globals = _ref$globals === void 0 ? '' : _ref$globals;

  return new Promise(function (resolve, reject) {
    var timer = null; // 当前环境已载入对应js

    if (globals && window[globals]) {
      resolve();
      return;
    }

    var script = document.createElement('script');

    var clear = function clear() {
      if (timer !== null) {
        clearTimeout(timer);
        timer = null;
      }

      document.body.removeChild(script);
    };

    var handleLoadError = function handleLoadError(e) {
      clear();
      reject(e);
    };

    if (timeout) {
      timer = window.setTimeout(function () {
        handleLoadError('timeout');
      }, timeout);
    }

    script.id = id;
    script.src = url;
    script.async = async;

    script.onload = function () {
      clear();
      resolve();
    };

    script.onerror = handleLoadError;
    document.body.appendChild(script);
  });
}

var EXIF = 'https://code.bdstatic.com/npm/exif-js@2.3.0/exif.js';
var HTML2CANVAS = 'https://code.bdstatic.com/npm/html2canvas@1.0.0-rc.4/dist/html2canvas.min.js';
/**
 * 空函数
 */

var emptyFn = function emptyFn() {// do nothing...
};
/**
 * 微信weixin分享
 * @param optionsArr - 分享参数集合
 * @param weixinCallbacks - 初始化微信接口回调
 * @param  weixinCallbacks.loadError - 加载微信apijs出错
 * @param  weixinCallbacks.initError - 初始化微信接口出错
 * @param  weixinCallbacks.configError - 配置微信接口出错
 */


var weixinShare = function () {
  if (getPlatInfo().isServer) {
    return;
  } // 分享内容选项


  var timelineOpt;
  var friendOpt;
  var weiboOpt;
  var weixinApiReady = false;
  var tryConfigTime = 0; // config失败，尝试次数

  var onError = {};
  var maxTryConfigTime = 5;
  var weixinApiUrl = window.location.protocol + '//res.wx.qq.com/open/js/jweixin-1.6.0.js';
  var jsApiList = [// 所有要调用的 API 都要加到这个列表中
  'updateTimelineShareData', // 朋友圈
  'updateAppMessageShareData', // 分享好友
  'onMenuShareWeibo'];

  function initWeixinApi(callback) {
    // 然后拉取token
    // jsonp('http://172.22.97.126/weixin/sample/php/test.php?url=' + location.href.split('#')[0] + '&callback=?', function (data) {
    var url = window.location.protocol + '//zt.baidu.com/weixin/ticket?url=' + encodeURIComponent(location.href.split('#')[0]);
    jsonp(url).then(function (data) {
      // jsonp('http://cq01-rdqa-dev038.cq01.baidu.com:8003/weixin/ticket?url=' + encodeURIComponent(location.href.split('#')[0]) + '&callback=?', function (data) {
      if (data && data.errno === 0) {
        data = data.data; // console.log(data);

        window.wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: jsApiList
        }); // config验证通过后，会执行wx.ready，将验证通过标识放入回调
        // weixinApiReady = true;

        callback && callback();
      }
    }).catch(onError.initError);
  }

  function setWeixinOptions() {
    // 设置微信分享成功
    window.wx.ready(function () {
      // alert('config succeed');
      // 验证通过标识
      weixinApiReady = true; // alert("initoption");
      // 朋友圈

      window.wx.updateTimelineShareData({
        title: timelineOpt.text,
        // 分享标题
        link: timelineOpt.url,
        // 分享链接
        imgUrl: timelineOpt.pic,
        // 分享图标
        success: function success() {
          // 用户确认分享后执行的回调函数
          timelineOpt.confirm && timelineOpt.confirm();
        },
        cancel: function cancel() {
          // 用户取消分享后执行的回调函数
          timelineOpt.cancel && timelineOpt.cancel();
        }
      }); // 好友

      window.wx.updateAppMessageShareData({
        title: friendOpt.title,
        // 分享标题
        desc: friendOpt.text,
        // 分享描述
        link: friendOpt.url,
        // 分享链接
        imgUrl: friendOpt.pic,
        // 分享图标
        type: 'link',
        // 分享类型,music、video或link，不填默认为link
        dataUrl: '',
        // 如果type是music或video，则要提供数据链接，默认为空
        success: function success() {
          // 用户确认分享后执行的回调函数
          friendOpt.confirm && friendOpt.confirm();
        },
        cancel: function cancel() {
          // 用户取消分享后执行的回调函数
          friendOpt.cancel && friendOpt.cancel();
        }
      }); // 微博

      window.wx.onMenuShareWeibo({
        title: '',
        // 分享标题
        desc: weiboOpt.text,
        // 分享描述
        link: weiboOpt.url,
        // 分享链接
        imgUrl: weiboOpt.pic,
        // 分享图标
        success: function success() {
          // 用户确认分享后执行的回调函数
          weiboOpt.confirm && weiboOpt.confirm();
        },
        cancel: function cancel() {
          // 用户取消分享后执行的回调函数
          weiboOpt.cancel && weiboOpt.cancel();
        }
      });
    }); // 设置微信分享失败

    window.wx.error(function () {
      tryConfigTime++;

      if (tryConfigTime > maxTryConfigTime) {
        tryConfigTime = 0;
        onError.configError && onError.configError();
        return;
      }

      initWeixinApi(setWeixinOptions);
    });
  }
  /**
   * opt增加初始化失败回调，一共有三种情况：
   *     1：import拉weixinApi失败 -> loadError
   *     2：jsonp请求失败 -> initError
   *     3：config失败 -> configError
   */


  return function (optionsArr, callbackOptions) {
    if (!getPlatInfo().isWechat) {
      return;
    } // 过滤选项


    optionsArr.forEach(function (e) {
      if (e.hasOwnProperty('src')) {
        var src = e.src;

        switch (src) {
          case 'weibo':
          case 'sina_weibo':
            weiboOpt = e;
            break;

          case 'weixin':
            friendOpt = e;
            break;

          case 'friend':
          case 'weixin_friend':
            timelineOpt = e;
            break;

          default:
            throw new Error('分享参数不对！');
        }
      }
    });
    onError = objectType(callbackOptions) === 'Object' ? callbackOptions : {};
    onError.loadError = onError.loadError || emptyFn;
    onError.initError = onError.initError || emptyFn;
    onError.configError = onError.configError || emptyFn; // 先拉取weixinApi

    if ('wx' in window) {
      if (weixinApiReady) {
        setWeixinOptions();
      } else {
        initWeixinApi(setWeixinOptions);
      }
    } else {
      getScript(weixinApiUrl).then(function () {
        return initWeixinApi(setWeixinOptions);
      }).catch(onError.loadError);
    }
  };
}();
/**
 * 手百分享
 * @param   optionsArr - 分享参数集合
 */


function shoubaiShare(optionsArr) {
  if (!getPlatInfo().is('baiduboxapp')) {
    return null;
  }

  var shareObj = {};
  var formattedObj = {};

  if (objectType(optionsArr) === 'Object') {
    formattedObj = optionsArr || {};
  } else {
    optionsArr.forEach(function (e) {
      if (e.src === 'weixin') {
        formattedObj = e;
      }
    });
  }

  shareObj.title = formattedObj.title || document.title;
  shareObj.content = formattedObj.text || document.title;
  shareObj.iconUrl = formattedObj.weixinPic || formattedObj.pic || 'https://maporp1.bdimg.com/static/weatherv2/lib/others/logo.png';
  shareObj.imageUrl = formattedObj.weiboPic || formattedObj.pic || 'https://maporp1.bdimg.com/static/weatherv2/lib/others/logo.png';
  shareObj.linkUrl = formattedObj.url || location.origin + location.pathname; // 下载手百sdk

  if (!('Box' in window)) {
    getScript('https://webmap0.bdimg.com/zt/client/sbsdk.js').then(function () {
      window.Box.nativeShare(shareObj);
    });
  } else {
    window.Box.nativeShare(shareObj);
  }
}
/**
 * 新浪weibo分享
 * @param opts - 分享参数集合
 * @param opts.title - 分享内容，无需encodeURI
 * @param opts.url - 分享链接，无需encodeURI
 * @param opts.pic - 分享图片的url，无需encodeURI。新浪的接口多张图片尚未完全开放，暂时只能分享一张
 * @param opts.ralateUid - 相关微博Uid，如果有此项，分享内容会自动 @相关微博
 * @param opts.appkey - 分享来源的appkey，如果有此项，会在微博正文地下，显示“来自XXX”
 */


function weiboShare(opts) {
  var sinaUrl = 'http://service.weibo.com/share/' + (getPlatInfo().isMobile ? 'mobile' : 'share') + '.php';
  sinaUrl = appendParam(sinaUrl, opts);

  try {
    window.open(sinaUrl);
  } catch (e) {}
}
/**
 * 调用native接口，调起分享到微博、微信的弹出选框
 * 在这种情况下分享到微博或微信只用在页面中做一个按钮，点击这个按钮后由客户端从底部弹起遮罩层，在层中有具体分享到各个社交平台的按钮
 * @param   optionsArr - 分享参数集合
 * @param  initMapShare - 选择行为是设置右上角内容(true)或者调起分享组件(false)，默认为false
 */


function mapShare(optionsArr) {
  var initMapShare = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!getPlatInfo().isNative) {
    return null;
  }

  var httpReg = /http[s]{0,1}:\/\/[A-Za-z0-9\.-]{3,}\.[A-Za-z]{3}/;
  var httpsReg = /https?:\/\/[A-Za-z0-9\.-]{3,}\.[A-Za-z]{3}/;
  var nativeUrlArr = [];
  var shareBdApiUrl = initMapShare ? 'bdapi://setShareContent?' : 'bdapi://openSharePrompt?'; // check loop

  optionsArr.forEach(function (e) {
    var formattedObj = {};
    var title;
    var content;
    var contentType;

    if (e.hasOwnProperty('src')) {
      var src = e.src;

      switch (src) {
        case 'weibo':
        case 'sina_weibo':
          formattedObj.shareTo = 'sina_weibo'; // weibo need add url to text(content)

          if (getPlatInfo().isIos) {
            content = e.text + e.url;
          } else {
            content = e.text;
          }

          contentType = 'text';
          break;

        case 'weixin':
          formattedObj.shareTo = 'weixin';
          content = e.text;
          break;

        case 'friend':
        case 'weixin_friend':
          formattedObj.shareTo = 'weixin_friend';
          title = e.text;
          break;

        default:
          throw new Error('分享参数错误！');
      }

      formattedObj.url = e.url;
      formattedObj.title = title ? title : e.title ? e.title : '分享百度地图';
      formattedObj.content = content;
      formattedObj.contentType = contentType ? contentType : e.contentType ? e.contentType : 'text'; // pic -> imageSource
      // http://xxxxxxx.png 某个具体url
      // icon 百度地图的小图标
      // capture_screen 截图，目前客户端已制止，我们暂时用不上，前端js组件暂未支持

      formattedObj.imageSource = e.pic && (httpReg.test(e.pic) || httpsReg.test(e.pic)) ? e.pic : 'icon';
    }

    nativeUrlArr.push(formattedObj);
  });

  if (nativeUrlArr.length) {
    shareBdApiUrl += encodeURIComponent(JSON.stringify({
      shareList: nativeUrlArr
    }));
  }

  requestBdApi(shareBdApiUrl);
}

/**
 * 普通链接分享配置
 * @public
 * @param shareConfig - 分享配置信息
 * @param shareConfig.wxTitle - 微信标题
 * @param shareConfig.wxText - 微信正文
 * @param shareConfig.url - url
 * @param shareConfig.wxFriendText - 微信朋友圈正文
 * @param shareConfig.wxPic - 微信icon
 * @param shareConfig.weiboPic - 微博icon
 * @param shareConfig.weiboText - 微博正文
 * @param  needWeibo - 是否需要分享到微博，默认为true
 * @returns   - 完整分享配置
 */
function makeTextShareData(shareConfig) {
  var needWeibo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var _shareConfig$url = shareConfig.url,
      url = _shareConfig$url === void 0 ? location.protocol + '//' + location.host + location.pathname : _shareConfig$url,
      wxTitle = shareConfig.wxTitle,
      wxText = shareConfig.wxText,
      wxFriendText = shareConfig.wxFriendText,
      wxPic = shareConfig.wxPic,
      weiboText = shareConfig.weiboText,
      weiboPic = shareConfig.weiboPic;
  var SHARE_DATA = [{
    src: 'weixin',
    // 'weixin好友'
    title: wxTitle,
    text: wxText,
    url: appendParam(url, {
      fr: 'weixin'
    }),
    contentType: 'text',
    pic: wxPic
  }, {
    src: 'friend',
    // 'weixin朋友圈'
    text: wxFriendText,
    url: appendParam(url, {
      fr: 'weixin_friends'
    }),
    contentType: 'text',
    pic: wxPic
  }];

  if (needWeibo) {
    SHARE_DATA.push({
      src: 'weibo',
      // 'weibo'
      text: weiboText,
      url: appendParam(url, {
        fr: 'weibo'
      }),
      pic: weiboPic,
      contentType: 'text'
    });
  }

  return SHARE_DATA;
}
/**
 * 初始化微信分享、地图端分享、手百分享
 * @private
 * @param optionsArr - 分享参数集合
 * @param shareConfig.wxTitle - 微信标题
 * @param shareConfig.wxText - 微信正文
 * @param shareConfig.url - url
 * @param shareConfig.wxFriendText - 微信朋友圈正文
 * @param shareConfig.wxPic - 微信icon
 * @param shareConfig.weiboPic - 微博icon
 * @param shareConfig.weiboText - 微博正文
 * @param  needWeibo - 是否需要分享到微博，默认为true
 *          object: {title, text, url, weiboPic, weixinPic}
 *          array: [{src:"weibo",text,url,contentType:"text",pic,confirm,cancal},{src:"weixin",title,text,url,contentType:"text",pic,confirm,cancal},{src:"friend",text,url,contentType,pic,confirm,cancal}]
 *          其中confirm,cancal为微信中分享成功、失败的回调
 * @param weixinCallbacks - 初始化微信接口回调
 * @param  weixinCallbacks.loadError - 加载微信apijs出错
 * @param  weixinCallbacks.initError - 初始化微信接口出错
 * @param  weixinCallbacks.configError - 配置微信接口出错
 * @param  inited - 是否已经初始化分享，默认值为false
 */


var _smartShare = function () {
  var savedOptionsArr;
  var savedShoubaiOptionsObj;
  var savedWeixinCallbacks;
  return function (optionsArr, weixinCallbacks) {
    var inited = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!inited) {
      if (objectType(optionsArr) === 'Object') {
        savedOptionsArr = makeTextShareData(optionsArr);
      } else {
        optionsArr.sort(function (x, y) {
          var arr = ['weixin', 'friend', 'weixin_friend', 'weibo', 'sina_weibo'];
          return arr.indexOf(x.src) > arr.indexOf(y.src) ? 1 : -1;
        });
        savedOptionsArr = optionsArr;
      }

      savedShoubaiOptionsObj = optionsArr;
      savedWeixinCallbacks = weixinCallbacks; // 初始化地图端右上角分享

      if (getPlatInfo().isNative) {
        mapShare(savedOptionsArr, true);
      } // 初始化微信端右上角分享


      if (getPlatInfo().isWechat) {
        weixinShare(savedOptionsArr, savedWeixinCallbacks);
      } // 初始化手百分享


      if (getPlatInfo().is('baiduboxapp')) {
        shoubaiShare(savedShoubaiOptionsObj);
      }
    } else {
      if (savedOptionsArr) {
        if (getPlatInfo().isNative) {
          // 打开地图组件
          mapShare(savedOptionsArr, false);
        } else {
          // 分享到微博
          savedOptionsArr.some(function (e) {
            if (e.hasOwnProperty('src') && (e.src === 'weibo' || e.src === 'sina_weibo')) {
              weiboShare({
                title: e.text,
                url: e.url,
                pic: e.pic
              });
            }
          });
        }
      }
    }
  };
}();
/**
 * 打开地图客户端分享面板
 */


function openShare() {
  _smartShare(undefined, undefined, true);
}
/**
 * 初始化地图客户端分享
 * @param optionsArr - 分享参数集合
 *          Object: {title, text, url, weiboPic, weixinPic}
 *          Array: [{src:"weibo",text,url,contentType:"text",pic,confirm,cancal},{src:"weixin",title,text,url,contentType:"text",pic,confirm,cancal},{src:"friend",text,url,contentType,pic,confirm,cancal}]
 *          其中confirm,cancal为微信中分享成功、失败的回调
 * @param weixinCallbacks - 初始化微信接口回调
 * @param weixinCallbacks.loadError - 加载微信apijs出错
 * @param weixinCallbacks.initError - 初始化微信接口出错
 * @param weixinCallbacks.configError - 配置微信接口出错
 */


function initShare(optionsArr, weixinCallbacks) {
  _smartShare(optionsArr, weixinCallbacks, false);
}
/**
 * 打开微信客户端
 */


function openWeixin() {
  // if (window.yy && window.yy.naa) {
  //     const weixinUrl = 'weixin://';
  //     setTimeout(() => {
  //         window.yy.naa.openBaiduMap(weixinUrl);
  //         window.yy.naa.openBaiduMap(weixinUrl);
  //     }, 40);
  // }
  // 微信7.0.14版本调起有问题，会打开一个空白页，7.0.15版本已修复（2020.6.1号上架）
  location.href = 'weixin://';
}
/**
 * 大图分享配置
 * @param posterUrl - 大图资源
 * @returns - 完整大图分享配置
 */


function makePicShareData(posterUrl) {
  // 'weibo | weixin | friend'
  return [{
    src: 'weixin',
    contentType: 'media',
    pic: posterUrl
  }, {
    src: 'friend',
    contentType: 'media',
    pic: posterUrl
  }, {
    src: 'weibo',
    contentType: 'media',
    pic: posterUrl
  }];
}
/**
 * 初始化微信分享授权
 * @param param - 参数集合
 * @param param.gameid - 业务信息，其中activity字段必填
 * @param param.shareConfig - 分享配置信息
 */


function initShareAuth() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$gameid = _ref.gameid,
      gameid = _ref$gameid === void 0 ? {} : _ref$gameid,
      _ref$shareConfig = _ref.shareConfig,
      shareConfig = _ref$shareConfig === void 0 ? {} : _ref$shareConfig;

  if (!shareConfig || _typeof(shareConfig) !== 'object') {
    console.error('[Error]: shareConfig error');
    return;
  }

  if (_typeof(gameid) === 'object') {
    gameid = JSON.stringify(gameid);
  }

  var config = JSON.parse(JSON.stringify(shareConfig));
  var AUTH_SERVICE = 'https://zt.baidu.com/activity/wechat/auth';
  var url = appendParam(AUTH_SERVICE, {
    url: config.url,
    gameid: gameid
  });
  config.url = url; // 调起微信授权分享面板屏蔽微博渠道

  initShare(makeTextShareData(config, false));
}
/**
 * 地图客户端定制参数分享
 * @param shareData - 分享参数集合
 */


function customShare(shareData) {
  mapShare(shareData, false);
}
/**
 * base64 to blob
 * @param base64Data - base64
 * @return blob对象
 */


function dataURItoBlob(base64Data) {
  // 生成图片的base64格式
  var byteString;

  if (base64Data.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(base64Data.split(',')[1]);
  } else {
    byteString = unescape(base64Data.split(',')[1]);
  }

  var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
  var ia = new Uint8Array(byteString.length);

  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], {
    type: mimeString
  });
}

/**
 * @private
 * 通过sts服务获取临时AK/SK
 * @param stsService - sts服务地址
 * @see => http://wiki.baidu.com/pages/viewpage.action?pageId=921305250#PGC%E5%B9%B3%E5%8F%B0%E6%8E%A5%E5%8F%A3-3%E3%80%81/sts
 */
function getBosConfig(stsService) {
  return jsonp(stsService).then(function (res) {
    if (res.code === 0) {
      var result = res.result;
      return {
        endpoint: result.boshost,
        sessionToken: result.sessionToken,
        credentials: {
          ak: result.accessKeyId,
          sk: result.secretAccessKey
        }
      };
    }

    throw new TypeError(res.result || 'sts服务异常');
  });
}
/**
 * 上传百度云对象存储
 * @param stsService - 获取token 服务地址
 * @param bucket - bos bucket
 * @param storedpath - 存储路径(bucket下的文件夹路径)
 * @param blob - blob对象，可以由dataURItoBlob方法生成
 * @param callback - 成功回调
 * @param onErr - 失败回调
 * @description 依赖 baidubce-sdk.bundle.min.js
 */


function uploadToBos(stsService, bucket, storedpath, blob, callback, onErr) {
  getBosConfig(stsService).then(function (config) {
    var opt = {
      'Content-Type': 'image/jpeg'
    };
    var client = new window.baidubce.sdk.BosClient(config);
    client.putObjectFromBlob(bucket, storedpath, blob, opt).then(function () {
      var bosUrl = "https://".concat(bucket, ".cdn.bcebos.com/").concat(storedpath);
      callback && callback(bosUrl);
    }).catch(function (error) {
      console.error(error);
      onErr && onErr();
    });
  }).catch(function (error) {
    console.error(error);
    onErr && onErr();
  });
}

/**
 * 生成分享海报
 * @param shareBox 海报布局容器
 * @param drawConfig 配置项
 * @param drawConfig.stsService - sts服务地址
 * @param drawConfig.bucket - bos bucket
 * @param drawConfig.pathPrefix - bos 存储路径前缀
 * @param drawConfig.imgType - 生成图片类型，可选，默认png
 * @param drawConfig.logging - 是否开启调试，可选，默认false
 * @param drawConfig.width - 截图宽度,可选，默认容器宽度
 * @param drawConfig.height - 截图高度，可选，默认容器高度
 * @returns - Promise
 */
function drawPoster(shareBox, drawConfig) {
  var stsService = drawConfig.stsService,
      bucket = drawConfig.bucket,
      pathPrefix = drawConfig.pathPrefix,
      _drawConfig$imgType = drawConfig.imgType,
      imgType = _drawConfig$imgType === void 0 ? 'png' : _drawConfig$imgType,
      _drawConfig$logging = drawConfig.logging,
      logging = _drawConfig$logging === void 0 ? false : _drawConfig$logging,
      _drawConfig$width = drawConfig.width,
      width = _drawConfig$width === void 0 ? shareBox.clientWidth : _drawConfig$width,
      _drawConfig$height = drawConfig.height,
      height = _drawConfig$height === void 0 ? shareBox.clientHeight : _drawConfig$height;
  return new Promise(function (resolve, reject) {
    var scriptOnload = function scriptOnload() {
      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop; // 保证在截图的一瞬间，截图的内容出现在可视区

      window.scrollTo(0, 0);
      window.html2canvas(shareBox, {
        useCORS: true,
        // 设置允许跨域资源共享
        allowTaint: false,
        // 设置是不允许跨源图像污染canvas
        logging: logging,
        // 设置为调试目的启用记录
        width: width,
        // 设置canvas尺寸与所截图尺寸相同，防止白边
        height: height
      }).then(function (canvas) {
        var random = Math.random().toString().split('.')[1];
        var timestamp = new Date().getTime();
        var filename = "".concat(random, "_").concat(timestamp, ".").concat(imgType);
        var key = "".concat(pathPrefix.replace(/(^\/)|(\/$)/g, ''), "/").concat(filename);
        var base64 = canvas.toDataURL();
        var blob = dataURItoBlob(base64);
        uploadToBos(stsService, bucket, key, blob, function (imgUrl) {
          resolve(imgUrl);
        }, function () {
          reject('Bos上传资源异常');
        });
      }).catch(function (e) {
        reject(e);
      });
      window.scrollTo(0, scrollTop);
    };

    loadScript(HTML2CANVAS, {
      globals: 'html2canvas',
      timeout: 2000
    }).then(function () {
      return scriptOnload();
    }).catch(function (e) {
      return reject(e);
    });
  });
}

/**
 * 表单上传图片
 * @param event input事件对象
 * @param uploadConfig 配置项
 * @param uploadConfig.stsService - sts服务地址
 * @param uploadConfig.bucket - bos bucket
 * @param uploadConfig.pathPrefix - bos 存储路径前缀
 * @param uploadConfig.imgType - 生成图片类型，可选，默认png
 * @param uploadConfig.quality - 图片质量,可选，默认0.7，quality值越小，所绘制的图像越模糊
 * @returns -  Promise
 */
function uploadImage(event, uploadConfig) {
  var file = event.target.files[0];
  var stsService = uploadConfig.stsService,
      bucket = uploadConfig.bucket,
      pathPrefix = uploadConfig.pathPrefix,
      _uploadConfig$imgType = uploadConfig.imgType,
      imgType = _uploadConfig$imgType === void 0 ? 'png' : _uploadConfig$imgType,
      _uploadConfig$quality = uploadConfig.quality,
      quality = _uploadConfig$quality === void 0 ? 0.7 : _uploadConfig$quality;
  return new Promise(function (resolve, reject) {
    var Orientation; // 图片方向

    var image = new Image();
    var reader = new FileReader();

    if (!file) {
      reject('上传图片异常');
      return;
    }

    loadScript(EXIF, {
      globals: 'EXIF',
      timeout: 2000
    }).then(function () {
      window.EXIF.getData(file, function () {
        Orientation = window.EXIF.getTag(file, 'Orientation');
        reader.readAsDataURL(file);
      });
    }).catch(function (e) {
      return reject(e);
    });

    reader.onload = function (evt) {
      var _evt$target;

      image.src = String((_evt$target = evt.target) === null || _evt$target === void 0 ? void 0 : _evt$target.result);

      image.onload = function () {
        // 默认按比例压缩
        var scale = image.width / image.height;
        var w = 500;
        var h = w / scale;
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        canvas.width = w;
        canvas.height = h;

        if (ctx) {
          // 根据图片旋转角度进行旋转校正
          if (Orientation && Orientation !== 1) {
            switch (Orientation) {
              case 6:
                ctx.drawImage(image, 0, 0, w, h);
                break;

              case 3:
                // 需要旋转180度
                ctx.rotate(Math.PI);
                ctx.drawImage(image, -w, -h, w, h);
                break;

              case 8:
                // 需要逆时针旋转90度
                canvas.width = h;
                canvas.height = w;
                ctx.rotate(3 * Math.PI / 2);
                ctx.drawImage(image, -w, 0, w, h);
                break;
            }
          } else {
            ctx.drawImage(image, 0, 0, w, h);
          }
        }

        var base64Url = canvas.toDataURL('image/png', quality);
        var random = Math.random().toString().split('.')[1];
        var timestamp = new Date().getTime();
        var filename = "".concat(random, "_").concat(timestamp, ".").concat(imgType);
        var key = "".concat(pathPrefix.replace(/(^\/)|(\/$)/g, ''), "/").concat(filename);
        var blob = dataURItoBlob(base64Url);
        uploadToBos(stsService, bucket, key, blob, function (imgUrl) {
          resolve(imgUrl);
        }, function () {
          reject('Bos上传资源异常');
        });
      };
    };

    reader.onerror = function () {
      reject('读取文件失败');
    };
  });
}

/**
 * @module smoothScroll
 * @file 平滑滚动插件
 * @author *
 */

/**
 * @private
 * scrollTo pollify
 * @param element 滑动元素 DOM元素
 * @param top
 */
function elScrollTo(element, option) {
  if (element.scrollTo) {
    element.scrollTo(option);
  } else {
    element.scrollTop = option.top;
  }
}

/**
 * @description 平滑滚动插件
 * @param destination - 滚动目标位置
 * @param options 可选参数
 * @param options.el - 滚动的外层容器Dom元素
 * @param options.duration - 持续时间
 * @param options.easing -  动效方式
 * @param options.callback - 滚动完成回调
 */
function smoothScroll(destination) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      el = _ref.el,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 200 : _ref$duration,
      _ref$easing = _ref.easing,
      easing = _ref$easing === void 0 ? 'linear' : _ref$easing,
      callback = _ref.callback;

  var easings = {
    linear: function linear(t) {
      return t;
    },
    easeInQuad: function easeInQuad(t) {
      return t * t;
    },
    easeOutQuad: function easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad: function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic: function easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic: function easeOutCubic(t) {
      return --t * t * t + 1;
    },
    easeInOutCubic: function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart: function easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart: function easeOutQuart(t) {
      return 1 - --t * t * t * t;
    },
    easeInOutQuart: function easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    easeInQuint: function easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint: function easeOutQuint(t) {
      return 1 + --t * t * t * t * t;
    },
    easeInOutQuint: function easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    }
  };
  var startY = 0; // 滚动事件发生的元素

  var scrollable; // 整个文档的高度

  var documentHeight; // 窗口可视区的高度

  var windowHeight;

  if (el) {
    scrollable = el;
    startY = el.scrollTop;
    documentHeight = el.scrollHeight;
    windowHeight = el.clientHeight;
  } else {
    scrollable = window;
    startY = window.pageYOffset;
    documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight); // 可视

    windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  }

  var startTime = 'now' in window.performance ? performance.now() : new Date().getTime(); // 最后一屏在可视区内时，documentHeight - windowHeight是最大可滚动的位置，若小于目的位置，说明已无法滚动，只能滚动到documentHeight - windowHeight；否则是destinationOffset

  var destinationOffsetToScroll = Math.round(documentHeight - windowHeight < destination ? documentHeight - windowHeight : destination);
  return new Promise(function (resolve) {
    if ('requestAnimationFrame' in window === false) {
      elScrollTo(scrollable, {
        top: destinationOffsetToScroll,
        behavior: 'smooth'
      });

      if (callback) {
        callback();
      }

      resolve(null);
      return;
    }

    function scroll() {
      var now = 'now' in window.performance ? performance.now() : new Date().getTime();
      var time = Math.min(1, (now - startTime) / duration);
      var timeFunction = easings[easing](time);
      var destY = Math.ceil(timeFunction * (destinationOffsetToScroll - startY) + startY);
      elScrollTo(scrollable, {
        top: destY,
        behavior: 'smooth'
      });
      var currentScrollY = Math.ceil(el ? el.scrollTop : window.pageYOffset);

      if (currentScrollY === destinationOffsetToScroll) {
        if (callback) {
          callback();
        }

        resolve(null);
        return;
      }

      requestAnimationFrame(scroll);
    }

    scroll();
  });
}

/**
 * @module Storage
 * @file storage存取，可设置过期时间，不支持服务端渲染
 * @author liuyanan06 <liuyanan06@baidu.com>
 */
var storage;

if (!getPlatInfo().isServer) {
  storage = localStorage;
}
/**
 * 设置存储引擎，可选值为localStorage或sessionStorage，如果不是可选值，默认设为localStorage
 * @param type - 存储引擎名称
 */


var setStorage = function setStorage(type) {
  if (type === sessionStorage || type === 'sessionStorage') {
    storage = sessionStorage;
  } else {
    storage = localStorage;
  }
};
/**
 * 存储键值对，默认无过期时间
 * @param name - 键
 * @param value - 可为字符串 数组 对象格式
 * @param expiresDay 有效期，以天为单位，可选
 */


var setItem = function setItem(name, value, expiresDay) {
  if (!name || !value) {
    console.error('name or value is necessary!');
    return;
  }

  var options = {
    name: name,
    value: value,
    expires: expiresDay && expiresDay * 1000 * 60 * 60 * 24,
    startTime: Date.now() // 记录何时将值存入缓存，毫秒级

  }; // 如果options.expires设置了的话

  if (options.expires) {
    // 以options.name为key，options为值放进去
    storage.setItem(options.name, JSON.stringify(options));
  } else {
    // 如果options.expires没有设置，就stringify后存入
    options.value = JSON.stringify(options.value);
    storage.setItem(options.name, options.value);
  }
};
/**
 * 获取指定key的存储值
 * @param name - 键名
 * @returns  - 值
 */


var getItem = function getItem(name) {
  var item = storage.getItem(name); // 先将拿到的试着进行json转为对象的形式

  try {
    item = JSON.parse(item);
  } catch (e) {// 不处理错误
  } // 如果有startTime的值，说明设置了失效时间


  if (item && item.startTime) {
    // 将值取出减去刚存入的时间，与item.expires比较，如果大于就是过期了，如果小于或等于就还没过期
    if (Date.now() - item.startTime > item.expires) {
      // 缓存过期，清除缓存，返回false
      storage.removeItem(name);
      return false;
    } // 缓存未过期，返回值


    return item.value;
  } // 如果没有设置失效时间，直接返回值


  return item;
};
/**
 * 删除key存储
 * @param name - 键名
 */


var removeItem = function removeItem(name) {
  storage.removeItem(name);
};
/**
 * 获取所有储存的键值对，并剔除已过期的键值对
 * @returns {Object} - localStorage | sessionStorage
 */


var getStorage = function getStorage() {
  for (var key in storage) {
    if (storage.hasOwnProperty(key)) {
      getItem(key);
    }
  }

  return storage;
};
/**
 * 清空所有存储数据
 */


var clear = function clear() {
  storage.clear();
};

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

/**
 * @file 自定义的错误类
 * @author liuyanan06
 */
var CustomError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(CustomError, _Error);

  function CustomError(name, message) {
    var _this;

    _this = _Error.call(this, message) || this;
    _this.name = name || 'CustomError';
    _this.message = message || 'Default Error Message';
    _this.stack = new Error().stack;
    return _this;
  }

  return CustomError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

/**
 * @file weirwood监控平台引入
 * @see http://wiki.baidu.com/pages/viewpage.action?pageId=1009729840
 * @author zhuqijia
 */
/**
 * weirwood cdn
 * @see => https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/WWW6pX-lL3/60incnF1Zd/dC8gy4R2Pv0x6y
 */

var WEIRWOOD = 'https://dmpstatic.cdn.bcebos.com/weirwood-sdk/1/bundle.min.js'; // 默认配置

var weirwoodOptions = {
  common: {
    buildid: '',
    token: ''
  },
  error: {
    collectWindowErrors: true,
    collectUnhandledRejections: true,
    collectResourceLoadErrors: true,
    ignoreUrls: [// 本地开发屏蔽错误发送，请按需修改
      // 'localhost',
      // '127.0.0.1'
    ]
  },
  perf: {
    sampleRate: 1,
    spa: true,
    history: true,
    ignoreUrls: [// 本地开发屏蔽错误发送，请按需修改
      // 'localhost',
      // '127.0.0.1'
    ]
  }
};
var weirwoodInstance = null; // Weirwood实例

/**
* 初始化Weirwood对象并返回
* @description 本方法不兼容服务端渲染，使用时请注意
* @see => https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/WWW6pX-lL3/60incnF1Zd/kGVSEPWrQ8QLET
*
* @param Vue - vue框架对象
* @param weirJson - weirwood的json文件对象，包含buildid、token及tarAddress
* @param options - weirwood的定制化配置信息，默认为{}
* @return - Promise<Weirwood对象>
*/

var initVueWeirwood = function initVueWeirwood(Vue, weirJson) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var commonOptions = {
    common: {
      buildid: weirJson.buildid,
      token: weirJson.token
    }
  };
  return loadScript(WEIRWOOD, {
    globals: 'Weirwood',
    timeout: 2000
  }).then(function () {
    weirwoodInstance = window.Weirwood.init(Object.assign({}, weirwoodOptions, options, commonOptions)); // 核心：Hook Vue 的错误方法，调用 'weirwood' 的 'captureException' 方法

    Vue.config.errorHandler = function (err) {
      weirwoodInstance.error.captureException(err);
    };

    return weirwoodInstance;
  }).catch(function (e) {
    throw new Error("[weirwood-load-error]: ".concat(e));
  });
};
/**
 * 手动上报JS异常
 * @param name - 异常类型，建议命名`someError`，eg: customError
 * @param msg - 异常信息
 *
 * @see => https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/WWW6pX-lL3/60incnF1Zd/kGVSEPWrQ8QLET#anchor-a4bd3fd1-d759-11ec-972d-3530d834711d
 */

var captureException = function captureException(name, msg) {
  if (weirwoodInstance === null) {
    console.error('[Error] You need to call "initVueWeirwood" before using "CaptureException"');
    return;
  }

  var myError = new CustomError(name, msg);
  weirwoodInstance.error.captureException(myError);
};
/**
 * 手动上报API异常
 * @param params - API监控异常上报参数
 *
 * @see => https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/WWW6pX-lL3/60incnF1Zd/kGVSEPWrQ8QLET#anchor-a4bec670-d759-11ec-972d-3530d834711d
 */

var captureAPIException = function captureAPIException(params) {
  if (weirwoodInstance === null) {
    console.error('[Error] You need to call "initVueWeirwood" before using "captureAPIException"');
    return;
  }

  weirwoodInstance.error.captureAPIException(params);
};

export { Orienter, appendCallback, appendParam, awakeMapClient, btou, captureAPIException, captureException, clear, compareSv, convertLL2MC, convertMC2LL, copyText, customShare, dataURItoBlob, debounce, decodeUnicode, delCookie, drawPoster, encodeUnicode, fetchNAParams, filterProps, filterUrl, formatDate, formatNumber, genUUID, get, getAndroidVersion, getCookie, getCostShareApi, getDistanceOfMC, getDistanceOfPixel, getDuerToken, getHashCode, getIosVersion, getItem, getNativeInfo, getPageVisibility, getParamsFromUrl, getPlatInfo, getST, getScript, getStorage, getTimePeriod, goBdLogin, goToLogin, goWebLogin, initHaotianjing, initShare, initShareAuth, initVueWeirwood, isMapSchema, jsonp, ksort, lngLatToPixel, loadScript, makeAnchorRequest, makeIframeRequest, makePicShareData, makeSign, makeTextShareData, mapShare, objectType, openBdMap, openLayer, openShare, openUrlByOpenApi, openWeixin, parseObjectToUrlString, parseUrlStringToObject, pixelToLngLat, post, preload, removeItem, requestBaiduMapApi, requestBdApi, setCookie, setItem, setStorage, setUserAgent, smoothScroll, trim, trimLeft, trimRight, uploadImage, uploadToBos, utob };
